import { planUtils } from 'utils/plan/plan.utils';

export const getIsSubInternalAa = (sub: Subscription, plan: Plan) => {
  const planType = planUtils.getType(plan);

  return (
    planType === 'active-active' &&
    sub?.aa_rcp?.crdb_regions?.length > 0 &&
    Boolean(
      sub?.aa_rcp?.crdb_regions?.every((region) => region.cloud_account_ownership === 'internal')
    )
  );
};
